class ValueUtil {
  public static parseNumber(value: any) {
    let parsed: number | undefined;
    if (typeof value == 'string') {
      parsed = Number(value);
    } else if (typeof value == 'number') {
      parsed = value;
    }
    if (parsed == undefined || isNaN(parsed)) {
      return value;
    }
    return new Intl.NumberFormat(['tr-TR', 'en-US'], { useGrouping: true }).format(value);
  }

  public static numberShorten(value: number, digits: number = 1) {
    if (value < 1_000) {
      return value.toString();
    }
    if (value < 1_000_000) {
      return (value / 1_000).toFixed(digits) + 'K';
    }
    if (value < 1_000_000_000) {
      return (value / 1_000_000).toFixed(digits) + 'M';
    }
    return (value / 1_000_000_000).toFixed(digits) + 'B';
  }

  public static convertToStringFirstChar = (value: string) => {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  };

  public static convertEnumToString = (value: any) => {
    return value
      ?.toLowerCase()
      .split('_')
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  public static expandENotation(num: number): string {
    const str = String(num);
    if (!/e/i.test(str)) return str;

    const sign = num < 0 ? '-' : '';
    const [coefficient, exponent] = str.replace(/^-/, '').split(/e/i);
    const exp = Number(exponent);
    let [integer, fraction = ''] = coefficient.split('.');

    if (exp >= 0) {
      const zerosNeeded = exp - fraction.length;
      if (zerosNeeded > 0) {
        return sign + integer + fraction + '0'.repeat(zerosNeeded);
      }
      return sign + integer + fraction.slice(0, exp) + '.' + fraction.slice(exp);
    } else {
      const zerosNeeded = Math.abs(exp) - integer.length;
      if (zerosNeeded > 0) {
        return sign + '0.' + '0'.repeat(zerosNeeded) + integer + fraction;
      }

      const idx = integer.length + exp;
      return sign + integer.slice(0, idx) + '.' + integer.slice(idx) + fraction;
    }
  }

  public static formatNumber(value: number): string {
    try {
      const expanded = this.expandENotation(value);
      const [intPartRaw, fracPartRaw = '00'] = expanded.split('.');
      const intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return fracPartRaw ? `${intPart},${fracPartRaw}` : intPart;
    } catch {
      return '0,00';
    }
  }
}

export default ValueUtil;
